export const flattenArray = <T>(array: (T | T[])[]): T[] => {
  return array.reduce<T[]>((acc, val) => (Array.isArray(val) ? acc.concat(val) : acc.concat([val])), [])
}
